/**
 * Coach workout save: single numeric weight → number; ranges like "350-365" or "490LBS-510LBS" → string preserved.
 */
export function normalizeWeightForPayload(raw) {
  if (raw === null || raw === undefined || raw === "") return null;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  const t = String(raw).trim();
  if (t === "") return null;
  const rangeLoose = t.replace(/\s*(lbs|lb|kg)\s*/gi, "").trim();
  if (/^\d+(\.\d+)?\s*[-–—]\s*\d+(\.\d+)?$/iu.test(rangeLoose)) {
    return t;
  }
  const numMatch = t.match(/^(\d+(?:\.\d+)?)/);
  if (numMatch) return parseFloat(numMatch[1]);
  return t;
}
